
namespace RecordShield.Workspace {
    import fld = SerialKeyDetailsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SerialKeyDetailsGrid extends Serenity.EntityGrid<SerialKeyDetailsRow, any> {
        protected getColumnsKey() { return 'Workspace.SerialKeyDetails'; }
        protected getDialogType() { return SerialKeyDetailsDialog; }
        protected getLocalTextPrefix() { return SerialKeyDetailsRow.localTextPrefix; }
        protected getService() { return SerialKeyDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.unshift({
                field: 'Activations',
                name: '',
                format: ctx => '<a class="inline-action view-Activations" title="View Activations">' +
                    '<button class="btn btn-primary btn-xs" style="white-space: normal;max-width: 120px;word-break: break-word;">Activations</button></a>',
                width: 100,
                minWidth: 60,
                maxWidth: 100
            });
            Q.first(columns, x => x.field == fld.SerialKey).format =
                ctx => `<a href="javascript:;" class="SerialId-link">${Q.htmlEncode(ctx.value)}</a>`;

           
            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('view-Activations')) {
                var dlg = new ActivationsPickerDialog({
                    hideProducts: this.view.getItems().map(x => x.UserId)
                });
                dlg.dialogOpen();
            }

            if (target.hasClass("SerialId-link")) {
                e.preventDefault();                
                debugger;
                SerialKeyDetailsService.Retrieve({
                    EntityId: item.ID,
                    SerialKeyId: Number(item.SerialKeyId)
                }, response => {
                    new SerialKeyDetailsDialog().loadEntityAndOpenDialog(response.Entity);
                });
               
                
            }
        }
    }
}